import { useEffect, useState } from "react"
import { AlertCircle, ArrowRightLeft, Check, CheckCircle, X } from "lucide-react"
import { API_HOST } from "../../api_utils";

import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  OutlinedInput,
} from '@mui/material';
import { AcceptDeclineTransfer, getOrgEmployees, getTransferRequestsOfUser, transferProject } from "../../API/Company-admin/userApi";
import { useSelector } from "react-redux";
import { Autocomplete, TextField } from '@mui/material';
import { toast } from "react-toastify";
import Table from "../common/table/Table";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 6 + ITEM_PADDING_TOP, // Scrollable
      width: 250,
    },
  },
};

const projectOptions = [
  { id: "65bcbe10bf0ad32190f1c4f1", name: "Project 1" },
  { id: "64edb95a61e3645e8915a664", name: "Project 2" },
  { id: "78xyz123abc456lmn", name: "Project 3" },
];

export default function AccountTransfer() {
  const { userInfo } = useSelector((state) => state.userLogin);
  const { allProjectData, loading, error, emptyProject } = useSelector(
      (state) => state.allProjectData
    );
  const [showSuccess, setShowSuccess] = useState(false)
  const [recipientEmail, setRecipientEmail] = useState('');
  const [transferRequestList, setTransferRequestList] = useState([]);
  const [reason, setReason] = useState('');
  const [selectAll, setSelectAll] = useState(false);
  const [currentPage, setCurrentPage] = useState(1)
  
  const [employees, setEmployees] = useState([]);

  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const handleChange = (event) => {
    const value = event.target.value;
    if (value.includes("all")) {
      setSelectedProjects(["all"]);
    } else {
      setSelectedProjects(value.filter((v) => v !== "all"));
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    // recipientId: await getRecipientIdByEmail(recipientEmail),
    recipientId: selectedEmployee,
    projectsToTransfer: selectedProjects,
    reason,
  };
  

  try {
    const data = await transferProject(payload, userInfo?.token);
    if(data?.message){
      toast.success(data.message);
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong")
  }
  };

  const getEmployees = async ()=>{
    try {
      const data = await getOrgEmployees(userInfo?.organisation_id, userInfo?.token, 'admin=true');
      setEmployees(data);
    } catch (error) {
      console.log(error);
    }
  }

  const getTransferRequests = async () => {
      try {
        const response = await getTransferRequestsOfUser(userInfo.token);
        setTransferRequestList(response.data);
      } catch (error) {
        console.error("Error fetching docker images:", error)
      }
  }


  const requestAcceptDecline = async (id,action) => {
    const payload = {
      requestId: id,
      action: action
    };

    try {
      const response = await AcceptDeclineTransfer(payload, userInfo.token);
      console.log(response);
      if (response?.message) {
        toast.success(response.message);
      }
      getTransferRequests();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong")
    }
  }

  useEffect(()=>{
    getEmployees();
    getTransferRequests();
  },[userInfo?.organisation_id])
  
  const pageSize = 10
  const totalItems = transferRequestList?.length

  const handlePageChange = (page) => {
    setCurrentPage(page)
  }

  const columnsProjectPagesTable = [
      {
        header: "Sender Name",
        accessor: "sender_name",
      },
      {
        header: "Sender Email",
        accessor: "sender_email",
      },
      {
        header: "Projects",
        accessor: "projects",
        cell: (projects) => (
          <div className="flex flex-col text-xs gap-1">
            {projects?.map((project) => (
              <span key={project.project_id}>
                • {project.project_name}
              </span>
            ))}
          </div>
        ),
      },
      {
        header:"Reason for Transfer",
        accessor: "reason",
        cell: (value) => (
          <div title={value} className="text-xs">
            {value.length > 100 ? value.substring(0, 20) + '...' : value}
          </div>
        ),
      },
      {
        header: "Actions",
        accessor: "actions",
        cell: (value,row) => {
          return (
            <div className="py-2 flex gap-2">
              <button onClick={()=>requestAcceptDecline(row._id, "accept")} className="flex items-center text-xs bg-green-400 rounded-md px-2 py-1">
                 <Check className="mr-1 h-4 w-4" />
                  Accept
              </button>
              <button onClick={()=>requestAcceptDecline(row._id, "decline")} className="flex items-center text-xs bg-red-400 rounded-md px-2 py-1">
                  <X className="mr-1 h-4 w-4" />
                  Decline
              </button>
            </div>
        );
      }
    }
    ]
  


  return (
    <div className="grid gap-6">
      {showSuccess && (
        <div className="rounded-lg bg-green-50 p-4 text-green-800">
          <div className="flex">
            <div className="flex-shrink-0">
              <CheckCircle className="h-5 w-5" />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium">Success</h3>
              <div className="mt-2 text-sm">Transfer request has been initiated. The recipient will be notified.</div>
            </div>
          </div>
        </div>
      )}

      <div className="grid gap-6 md:flex items-center">
        <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
          <div className="border-b border-gray-200 px-6 py-4">
            <h3 className="text-lg font-semibold text-gray-900">Initiate Account Transfer</h3>
            <p className="text-sm text-gray-500">Transfer account ownership (projects can be transferred between organisation admins)</p>
          </div>
          <div className="px-6 py-4">
            <form onSubmit={handleSubmit} className="space-y-4">

              <div className="space-y-2">
                <label htmlFor="recipient" className="block text-sm font-medium text-gray-700">
                  Recipient Email
                </label>
                <Autocomplete
                  options={employees}
                  getOptionLabel={(option) => `${option.name} (${option.email})`}
                  value={employees.find(emp => emp._id === selectedEmployee) || null}
                  onChange={(event, newValue) => {
                    setSelectedEmployee(newValue ? newValue._id : null);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Recipient" placeholder="Search by name or email" fullWidth />
                  )}
                />
              </div>

              <FormControl fullWidth>
              <InputLabel id="project-multiselect-label">Projects to Transfer</InputLabel>
              <Select
                labelId="project-multiselect-label"
                multiple
                value={selectedProjects}
                onChange={handleChange}
                input={<OutlinedInput label="Projects to Transfer" />}
                renderValue={(selected) =>
                  selected.includes("all")
                    ? "All Projects"
                    : allProjectData
                        .filter((p) => selected.includes(p._id))
                        .map((p) => p.project_name)
                        .join(", ")
                }
                MenuProps={MenuProps}
              >
                <MenuItem value="all">
                  <Checkbox checked={selectedProjects.includes("all")} />
                  <ListItemText primary="All Projects" />
                </MenuItem>

                {allProjectData?.map((project) => (
                  <MenuItem key={project._id} value={project._id} disabled={selectedProjects.includes("all")}>
                    <Checkbox checked={selectedProjects.includes(project._id)} />
                    <ListItemText primary={project.project_name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>


              <div className="space-y-2">
                <label htmlFor="reason" className="block text-sm font-medium text-gray-700">
                  Reason for Transfer
                </label>
                <textarea
                  id="reason"
                  placeholder="Explain the reason for this transfer"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  rows={3}
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500"
                ></textarea>
              </div>

              <div className="flex gap-2 rounded-lg bg-amber-50 p-3 text-amber-800">
                <AlertCircle className="w-5 flex-shrink-0" />
                <p className="text-sm">
                  This action will initiate a transfer request. The recipient must accept for the transfer to complete.
                </p>
              </div>
            </form>
          </div>
          <div className="border-t border-gray-200 px-6 py-4">
            <button
              onClick={handleSubmit}
              className="flex items-center gap-2 rounded-md bg-red-600 px-4 py-2 font-medium text-white hover:bg-red-700"
            >
              <ArrowRightLeft className="h-4 w-4" />
              Initiate Transfer
            </button>
          </div>
        </div>

        <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
          <div className="border-b border-gray-200 px-6 py-4">
            <h3 className="text-lg font-semibold text-gray-900">Transfer Request</h3>
            <p className="text-sm text-gray-500">Recent projects transfer requests</p>
          </div>
          <div className="px-6 py-4">
            <div className="overflow-x-auto">
              <Table
                data={transferRequestList}
                columns={columnsProjectPagesTable}
                pagination={{
                  currentPage,
                  pageSize,
                  totalItems,
                  onPageChange: handlePageChange,
              }}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

